"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayProvisioningState = void 0;
var GatewayProvisioningState;
(function (GatewayProvisioningState) {
    GatewayProvisioningState["NOT_INVENTORIZED"] = "NOT_INVETORIZED";
    GatewayProvisioningState["INVENTORY"] = "INVENTORY";
    GatewayProvisioningState["ALLOCATED"] = "ALLOCATED";
})(GatewayProvisioningState || (exports.GatewayProvisioningState = GatewayProvisioningState = {}));
